import React, { useEffect } from 'react';
import { IHealthPlanMaster } from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import HealthPlanMasterPg from './HealthPlanMasterPg';
import { fetchHealthPlanMasterList } from '../Store/HealthPlanMasterReducer';

interface RootState {  
  healthPlanMasterList: {  
    healthPlanMasterList: IHealthPlanMaster[];  
    loading: boolean;  
  };  
}

const HealthPlanMaster: React.FC = () => {
  const { healthPlanMasterList, loading } = useSelector((state: RootState) => state.healthPlanMasterList);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchHealthPlanMasterList());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="contentDiv">
        <h3>Loading...</h3>
      </div>
    );
  }

  if (!healthPlanMasterList) {
    return <h3>Data not found...</h3>;
  }

  return <HealthPlanMasterPg healthPlanMasterLists={healthPlanMasterList} />;
}

export default HealthPlanMaster;
